import _ from 'lodash';
import * as moment from 'moment';
import { Validators } from '@angular/forms';

import { CampaignSchema } from './campaign';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

export const PeerToPeerPresetOptionSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(1), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'valueProvided',
        'value': 0,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
      'field': 'additionalInfoRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
      }
    }, {
      'field': 'additionalInfoDetail',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || ''
      }
    }, {
      'field': 'additionalInfoDesc',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || '',
        'validators': (data) => {
            return data.additionalInfoRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
        'setter': (data, value) => {
            if(value === true) {
                return true;
            }
            return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
        }
      }
    }, {
      'field': 'additionalInfoSelect',
      'value': [],
      'validators': [],
      'options': {
        'setter': (data, value) => value || [],
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectDesc',
      'value': '',
      'validators': [],
      'options': {
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    }]
};

export const PeerToPeerAmountOptionSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(1), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'image',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }]
};

export const PeerToPeerPercentageOptionSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'percent',
        'value': 0,
        'validators': [Validators.required, Validators.min(1), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'image',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }]
};

export const PeerToPeerTeamOptionSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    },{
        'field': 'imageCoverFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageCoverDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'goal',
        'value': 0,
        'validators': [Validators.required, Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'image',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'coverImage',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    },
    {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }]
};

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 8,
    'validators': [Validators.required]
})
clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [{
        'array': 'presetOptions',
        'schema': PeerToPeerPresetOptionSchema,
        'value': [],
        'validators': []
    },{
        'array': 'amountOptions',
        'schema': PeerToPeerAmountOptionSchema,
        'value': [],
        'validators': []
    },{
        'array': 'percentOptions',
        'schema': PeerToPeerPercentageOptionSchema,
        'value': [],
        'validators': []
    },{
        'array': 'teams',
        'schema': PeerToPeerTeamOptionSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'goal',
        'value': 0,
        'validators': [],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'hideCustom',
        'value': false,
        'validators': []
        
    },{
        'field': 'hideSelfContribution',
        'value': false,
        'validators': []
    },{
        'field': 'useAmounts',
        'value': true,
        'validators': []
    },{
        'field': 'usePercentage',
        'value': false,
        'validators': []
    }, {
        'field': 'teamEnabled',
        'value': false,
        'validators': []
    }, {
        'field': 'leaderboardTeamDefaultTab',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => {
                return data.teamEnabled ? value : false;
            }
        }
    }, {
        'field': 'additionalInfoRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'additionalInfoSelectRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'phoneNumRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'streetAddressRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'dedicationEnabled',
        'value': false,
        'validators': []
    }, {
        'field': 'pledgePerEvent',
        'value': false,
        'validators': []
    }, {
        'field': 'maxEventCount',
        'value': 0,
        'validators': []
    }, {
        'field': 'closingDateTimeUnix',
        'value': 0,
        'validators': []
    }, {
        'field': 'eventName',
        'value': '',
        'validators': []
    }]
}];
export const PeerToPeerSchema = clonedCampaignSchema;
